var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAirdropWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.485 13.2299C16.94 11.3166 15.2717 9.6482 13.3583 10.1032C12.46 10.3249 11.725 11.0599 11.5034 11.9582C11.0484 13.8716 12.7167 15.5399 14.63 15.0849C15.54 14.8632 16.275 14.1283 16.485 13.2299Z",
    stroke: "white",
    strokeWidth: 1.17,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0118 20.0549C23.0068 18.1883 24.2551 15.5399 24.2551 12.5882C24.2551 6.91823 19.6584 2.33325 14.0001 2.33325C8.34178 2.33325 3.74512 6.92989 3.74512 12.5882C3.74512 15.5516 5.00511 18.2232 7.02345 20.0899",
    stroke: "white",
    strokeWidth: 1.17,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33307 16.975C8.25973 15.8317 7.59473 14.2917 7.59473 12.5883C7.59473 9.05334 10.4647 6.18335 13.9997 6.18335C17.5347 6.18335 20.4047 9.05334 20.4047 12.5883C20.4047 14.2917 19.7397 15.82 18.6664 16.975",
    stroke: "white",
    strokeWidth: 1.17,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0165 19.4367L10.3365 21.525C9.00652 23.1934 10.1848 25.655 12.3198 25.655H15.6682C17.8032 25.655 18.9932 23.1817 17.6515 21.525L15.9715 19.4367C14.9682 18.165 13.0315 18.165 12.0165 19.4367Z",
    stroke: "white",
    strokeWidth: 1.17,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirdropWhite);
export default __webpack_public_path__ + "static/media/airdrop-white.663c72d9922ec2880916b2fb8352ef69.svg";
export { ForwardRef as ReactComponent };